import { c as _c } from "react/compiler-runtime";
import { Card } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useDocumentText from '@/entity/hooks/use-document-text';
import useRiskSignalGroupText from '../../hooks/use-risk-signal-group-text';
import type { RiskSignalSection } from '../../utils/group-risk-signals';
import { CardError, CardSkeleton } from '../card-title';
import Subsection from '../subsection';
import RiskSignalGroup from './components/risk-signal-group';
type OnboardingRiskSignalsProps = {
  /** Undefined until the signals load. */
  riskSignals?: RiskSignalSection[];
  error?: unknown;
};
const OnboardingRiskSignals = t0 => {
  const $ = _c(18);
  const {
    riskSignals,
    error
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.riskSignals"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const riskSignalGroupT = useRiskSignalGroupText();
  const documentT = useDocumentText();
  if (!riskSignals) {
    let t2;
    if ($[1] !== error) {
      t2 = <Subsection>{error ? <CardError error={error} /> : <CardSkeleton cards={2} rows={3} />}</Subsection>;
      $[1] = error;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (!riskSignals.length) {
    let t2;
    if ($[3] !== t) {
      t2 = t(_temp);
      $[3] = t;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== t2) {
      t3 = <Subsection><Card.Root><Card.Empty>{t2}</Card.Empty></Card.Root></Subsection>;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t2;
  if ($[7] !== documentT || $[8] !== riskSignalGroupT || $[9] !== riskSignals || $[10] !== t) {
    let t3;
    if ($[12] !== documentT || $[13] !== riskSignalGroupT || $[14] !== t) {
      t3 = t4 => {
        const {
          key,
          group,
          documentKind,
          signals
        } = t4;
        const groupLabel = riskSignalGroupT(group) || t(_temp2);
        const title = documentKind ? t(_temp3, {
          group: groupLabel,
          document: documentT(documentKind)
        }) : groupLabel;
        return <RiskSignalGroup key={key} title={title} group={group} signals={signals} />;
      };
      $[12] = documentT;
      $[13] = riskSignalGroupT;
      $[14] = t;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t2 = riskSignals.map(t3);
    $[7] = documentT;
    $[8] = riskSignalGroupT;
    $[9] = riskSignals;
    $[10] = t;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[16] !== t2) {
    t3 = <div className="flex flex-col gap-3 p-5">{t2}</div>;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
export default OnboardingRiskSignals;
function _temp($) {
  return $.noRiskSignals;
}
function _temp2($_0) {
  return $_0.group.other;
}
function _temp3($_1) {
  return $_1.groupWithDocument;
}